<template>
    <div class="photo-shelf">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "PhotoShelf",
        components: {

        },
        data () {
            return {

            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style lang="scss">
    .photo-shelf {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        flex-wrap: wrap;
        margin: 0 -10px;
    }

    .frame {
        flex: 1 1 200px;
        max-width: min(400px, calc(100% - 20px));
    }
</style>